import { RouteRecordRaw } from 'vue-router';
import { MenuItem } from '@/router/menuItem';

import { homeMenuItems } from '@/router/homeRouteAndMenuStructure';

const workspaceChildren: RouteRecordRaw[] = [
    {
        path: '',
        name: 'Home',
        component: () => import('@/catlMap/TheCatlMap.vue'),
        meta: {
            title: 'Home',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'map',
        name: 'Map',
        component: () => import('@/catlMap/TheCatlMap.vue'),
        meta: {
            title: 'Map',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/catlDashboard/TheCatlDashboard.vue'),
        meta: {
            title: 'Dashboard',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'sortie/:assetId',
        name: 'ActiveSortie',
        component: () => import('@/catlDashboard/ActiveSortiePage.vue'),
        meta: {
            title: 'Active Sortie',
            menuItems: homeMenuItems,
            feature: 'assets',
        },
    },
    {
        path: 'assets',
        name: 'CatlAssets',
        component: () => import('@/catlAssets/TheCatlAssets.vue'),
        meta: {
            title: 'Assets',
            menuItems: homeMenuItems,
            feature: 'assets',
        },
    },
    {
        path: 'assets/create',
        name: 'AssetCreate',
        component: () => import('@/catlAssets/AssetEditPage.vue'),
        meta: {
            title: 'Create Asset',
            menuItems: homeMenuItems,
            feature: 'assets',
        },
    },
    {
        path: 'assets/:id/edit',
        name: 'AssetEdit',
        component: () => import('@/catlAssets/AssetEditPage.vue'),
        meta: {
            title: 'Edit Asset',
            menuItems: homeMenuItems,
            feature: 'assets',
        },
    },
    {
        path: 'assets/:id',
        name: 'AssetView',
        component: () => import('@/catlAssets/AssetViewPage.vue'),
        meta: {
            title: 'View Asset',
            menuItems: homeMenuItems,
            feature: 'assets',
        },
    },
    {
        path: 'asset-types',
        name: 'CatlAssetTypes',
        component: () => import('@/catlAssetTypes/TheCatlAssetTypes.vue'),
        meta: {
            title: 'Asset Types',
            menuItems: homeMenuItems,
            feature: 'assetTypes',
        },
    },
    {
        path: 'asset-types/create',
        name: 'AssetTypeCreate',
        component: () => import('@/catlAssetTypes/AssetTypeEditPage.vue'),
        meta: {
            title: 'Create Asset Type',
            menuItems: homeMenuItems,
            feature: 'assetTypes',
        },
    },
    {
        path: 'asset-types/:id/edit',
        name: 'AssetTypeEdit',
        component: () => import('@/catlAssetTypes/AssetTypeEditPage.vue'),
        meta: {
            title: 'Edit Asset Type',
            menuItems: homeMenuItems,
            feature: 'assetTypes',
        },
    },
    {
        path: 'timeline',
        name: 'CatlTimeline',
        component: () => import('@/timeline/TheTimeline.vue'),
        meta: {
            title: 'Timeline',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'sensor-types',
        name: 'CatlSensorTypes',
        component: () => import('@/catlSensorTypes/TheCatlSensorTypes.vue'),
        meta: {
            title: 'Sensor Types',
            menuItems: homeMenuItems,
            feature: 'sensorTypes',
        },
    },
    {
        path: 'contacts',
        name: 'CatlContacts',
        component: () => import('@/catlContacts/TheCatlContacts.vue'),
        meta: {
            title: 'Contacts',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'tasks',
        name: 'CatlTasks',
        component: () => import('@/catlTasks/TheCatlTasks.vue'),
        meta: {
            title: 'Tasks',
            menuItems: homeMenuItems,
            feature: 'tasks',
        },
    },
    {
        path: 'tasks/create/manual',
        name: 'TaskCreateManual',
        component: () => import('@/catlTasks/ManualTaskCreatePage.vue'),
        meta: {
            title: 'Create Manual Task',
            menuItems: homeMenuItems,
            feature: 'tasks',
        },
    },
    {
        path: 'nodes/:nodeId/history',
        name: 'NodeHistory',
        component: () => import('@/catlTasks/NodeHistoryPage.vue'),
        meta: {
            title: 'Node History',
            menuItems: homeMenuItems,
            feature: 'tasks',
        },
    },
    {
        path: 'stanag/nodes/:nodeId',
        name: 'NodeDetails',
        component: () => import('@/stanag4617/NodeDetailsPage.vue'),
        meta: {
            title: 'Node Details',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'find',
        name: 'Find',
        component: () => import('@/find/TheFindPage.vue'),
        meta: {
            title: 'Find',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'rfc',
        name: 'CatlRfc',
        component: () => import('@/catlRfc/TheCatlRfc.vue'),
        meta: {
            title: 'Request for Collection',
            menuItems: homeMenuItems,
            feature: 'rfc',
        },
    },
    {
        path: 'intel',
        name: 'IntelSources',
        component: () => import('@/intel/TheIntelSources.vue'),
        meta: {
            title: 'Intel',
            menuItems: homeMenuItems,
            feature: 'intel',
        },
    },
    {
        path: 'jipoe',
        name: 'Jipoe',
        component: () => import('@/jipoe/TheJipoe.vue'),
        meta: {
            title: 'JIPOE',
            menuItems: homeMenuItems,
            feature: 'jipoe',
        },
    },
    {
        path: 'syncmatrix',
        name: 'CatlSyncMatrix',
        component: () => import('@/catlSyncMatrix/TheCatlSyncMatrix.vue'),
        meta: {
            title: 'Requests for Collection',
            menuItems: homeMenuItems,
            feature: 'rfc',
        },
    },
    {
        path: 'catlsettings',
        name: 'CatlSettings',
        component: () => import('@/catlSettings/TheCatlSettings.vue'),
        meta: {
            title: 'Settings',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'stanag4617',
        name: 'Stanag4617',
        component: () => import('@/stanag4617/TheStanag4617.vue'),
        meta: {
            title: 'STANAG-4817 Import',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'ais',
        name: 'Ais',
        component: () => import('@/ais/TheAisConfiguration.vue'),
        meta: {
            title: 'AIS',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'plan',
        name: 'Plan',
        component: () => import('@/catlPlan/TheCatlPlan.vue'),
        meta: {
            title: 'Plan',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'plan-editor',
        name: 'PlanEditor',
        component: () => import('@/planning/pages/EditorPage.vue'),
        meta: {
            title: 'Plan Editor',
            menuItems: homeMenuItems,
        },
    },
    {
        // The multi-repositories browser existed when an Operation could
        // hold N repositories. Post-Phase-0b there's exactly one
        // Repository per Operation, so the browser doesn't add value —
        // redirect to the Versions Viewer (streams + snapshots for that
        // single repo). Route name kept so existing router.push({ name:
        // 'PlanRepos' }) call sites continue to work without a fan-out
        // rename.
        path: 'plan-editor/repos',
        name: 'PlanRepos',
        redirect: { name: 'PlanVersions' },
    },
    {
        // Spreadsheet-style columnar view of the parsed schedule —
        // one section per day/window, columns mirror the SOE Excel.
        path: 'plan-editor/table',
        name: 'ScheduleTable',
        component: () => import('@/planning/pages/ScheduleTablePage.vue'),
        meta: {
            title: 'Schedule Table',
            menuItems: homeMenuItems,
        },
    },
    {
        // Declarative pool-driven tables — one page listing every `table`
        // block declared in the workspace's .sch files. See
        // Planning.LanguageServer/Schedule/Tables.cs.
        path: 'plan-editor/tables',
        name: 'PlanTables',
        component: () => import('@/planning/pages/TablesPage.vue'),
        meta: {
            title: 'Tables',
            menuItems: homeMenuItems,
        },
    },
    {
        // Legacy per-repo history URL. Kept as an alias so bookmarks
        // and links from the outside still resolve; routes to the new
        // Versions Viewer, which reads the same repo via param.
        path: 'plan-editor/repos/:repoName/history',
        name: 'PlanRepoHistory',
        component: () => import('@/planning/pages/VersionsViewer.vue'),
        meta: {
            title: 'Versions',
            menuItems: homeMenuItems,
        },
    },
    {
        // New Phase 4+5a route. Single Repository per Operation now, so
        // the URL doesn't carry a repo param — the store's only repo is
        // used.
        path: 'plan-editor/versions',
        name: 'PlanVersions',
        component: () => import('@/planning/pages/VersionsViewer.vue'),
        meta: {
            title: 'Versions',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'plan-editor/reviews',
        name: 'PlanReviewsList',
        component: () => import('@/planning/pages/ReviewsListPage.vue'),
        meta: {
            title: 'Reviews',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'plan-editor/reviews/:reviewId',
        name: 'PlanReview',
        component: () => import('@/planning/pages/ReviewPage.vue'),
        meta: {
            title: 'Review',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'plan/create',
        name: 'PlanCreate',
        component: () => import('@/catlPlan/PlanCreatePage.vue'),
        meta: {
            title: 'Create Plan',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'plan/:id/edit',
        name: 'PlanEdit',
        component: () => import('@/catlPlan/PlanEditPage.vue'),
        meta: {
            title: 'Edit Plan',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'controlmeasures',
        name: 'CatlControlMeasures',
        component: () => import('@/catlControlMeasures/TheCatlControlMeasures.vue'),
        meta: {
            title: 'Control Measures',
            menuItems: homeMenuItems,
            feature: 'controlMeasures',
        },
    },
    {
        path: 'controlmeasures/create',
        name: 'ControlMeasureCreate',
        component: () => import('@/catlControlMeasures/ControlMeasureEditPage.vue'),
        meta: {
            title: 'Create Control Measure',
            menuItems: homeMenuItems,
            feature: 'controlMeasures',
        },
    },
    {
        path: 'controlmeasures/:id',
        name: 'ControlMeasureView',
        component: () => import('@/catlControlMeasures/ControlMeasureViewPage.vue'),
        meta: {
            title: 'Control Measure Details',
            menuItems: homeMenuItems,
            feature: 'controlMeasures',
        },
    },
    {
        path: 'controlmeasures/:id/edit',
        name: 'ControlMeasureEdit',
        component: () => import('@/catlControlMeasures/ControlMeasureEditPage.vue'),
        meta: {
            title: 'Edit Control Measure',
            menuItems: homeMenuItems,
            feature: 'controlMeasures',
        },
    },
    {
        path: 'permissions',
        name: 'Permissions',
        component: () => import('@/permissions/ThePermissions.vue'),
        meta: {
            title: 'Permissions',
            menuItems: homeMenuItems,
            requiresAdmin: true,
        },
    },
    {
        path: 'bellhop',
        name: 'Bellhop',
        component: () => import('@/bellhop/TheBellhopPage.vue'),
        meta: {
            title: 'Bellhop Acoustic Field',
            menuItems: homeMenuItems,
        },
    },
    {
        path: 'admin/map-layers',
        name: 'AdminMapLayers',
        component: () => import('@/admin/mapLayers/MapLayersAdminPage.vue'),
        meta: {
            title: 'Map Layers',
            menuItems: homeMenuItems,
            requiresAdmin: true,
        },
    },
    {
        path: 'admin/users',
        name: 'Users',
        component: () => import('@/admin/users/TheUsers.vue'),
        meta: {
            title: 'Users',
            menuItems: homeMenuItems,
            requiresAdmin: true,
        },
    },
];

const authRoutes: RouteRecordRaw[] = [
    // Root redirect to operation selector or first operation
    {
        path: '/',
        redirect: () => ({ name: 'OperationRedirect' }),
    },
    {
        path: '/operation-redirect',
        name: 'OperationRedirect',
        component: () => import('@/home/OperationRedirectPage.vue'),
        meta: { allowAnonymousAuth: true },
    },
    {
        path: '/operation/:operationId',
        component: () => import('@/home/OperationLayout.vue'),
        children: workspaceChildren,
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/authentication/LoginPage.vue'),
        meta: {
            allowAnonymousAuth: true,
            fullscreen: true,
        },
    },
    {
        path: '/login-callback',
        name: 'LoginCallback',
        meta: {
            allowAnonymousAuth: true,
            fullscreen: true,
        },
        component: () => import('@/authentication/LoginCallback.vue'),
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/authentication/LogoutPage.vue'),
        meta: {
            allowAnonymousAuth: true,
            fullscreen: true,
        },
    },
    // Server-side PDF render target. Loaded by ChorusBackend's headless
    // Chromium (see /api/pdf/plan). Sits at the top-level, OUTSIDE the
    // /operation/:operationId layout, so the print browser doesn't have
    // to satisfy the outer layout's auth/redirect flow — the page reads
    // its own operationId + token from the query string. Marked
    // allowAnonymousAuth so the router doesn't bounce it to /login
    // during boot; content itself still requires a valid token in the
    // GraphQL calls.
    {
        path: '/print/plan',
        name: 'PrintablePlan',
        component: () => import('@/planning/pages/PrintablePlanPage.vue'),
        meta: { allowAnonymousAuth: true, fullscreen: true },
    },
    // Error pages
    {
        path: '/:pathMatch(.*)*',
        name: 'PageNotFound',
        component: () => import('@/ErrorPages/PageNotFound.vue'),
        meta: {
            title: 'PageNotFound',
            fullscreen: true,
            isUserWithoutCorrectRoles: false,
        },
        beforeEnter: async (to, from, next) => {
            next();
        },
    },
];

export const getRoutes = async () => {
    const routes = [...authRoutes];
    return routes;
};
